import { render, staticRenderFns } from "./SubcontractorExpensesMaterialsForm.vue?vue&type=template&id=0136631c&"
import script from "./SubcontractorExpensesMaterialsForm.vue?vue&type=script&lang=js&"
export * from "./SubcontractorExpensesMaterialsForm.vue?vue&type=script&lang=js&"
import style0 from "./SubcontractorExpensesMaterialsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VCard,VIcon})
